import { createEntityAdapter } from '@reduxjs/toolkit';
import { IBend } from 'application/components/api/Bend';

export const bendAdapter = createEntityAdapter<IBend, number>({
  selectId: (project) => project.bendID,
});
